var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{class:[
    'd-flex d-flex-r align-center menu-item',
    { 'is-selected': _vm.isSelected, 'is-focused': _vm.isFocused },
  ],attrs:{"to":_vm.path},on:{"click":_vm.toNavigate,"mouseover":_vm.expandItem}},[_c('span',{class:['image', _vm.customClass]}),_c('span',{class:['label', _vm.customClass]},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }